<template>
  <div>
    <v-card class="fullForm">
      <div class="fullText">
        <h3>
          شرايط و مراحل ثبت درخواست امریه توسط طلبه:
        </h3>
        <br />
        <ol>
          <li>
            بر اساس قوانين ستاد كل نيروهاي مسلح حداقل مدرك براي اعزام به سربازي
            در قالب طرح طلاب سرباز، مدرك سطح يك است.
          </li>
          <li>
            ارگان بكارگيرنده مي‌تواند مدرك بالاتر را شرط بكارگيري قرار دهد.
          </li>
          <li>
            داشتن جواز تلبس براي اعزام به خدمت الزامي است.
          </li>
          <li>
            اعزام به خدمت سرباز طلبه بر اساس نظر حراست و آموزش مركز مديريت خواهد
            بود.
          </li>
          <li>
            انصراف از خدمت باعث محروميت 2 ساله از ثبت‌نام مجدد مي‌شود.
          </li>
          <li>
            پيامد انتخاب گزينه اشتباه براي محل خدمت درخواست شده بر عهده متقاضي
            است.
          </li>
          <li>
            شركت در دوره آموزش نظامي در بدو خدمت الزامي بوده و انجام ماموريت در
            ارگان متقاضي، قبل از گذراندن دوره آموزش نظامي تخلف بوده و هيچ
            سابقه‌اي ثبت نمي‌شود.
          </li>
          <li>
            در صورت تاييد و اعزام نهايي، سرباز طلبه بايد ضمن رعايت شئونات طلبگي،
            بر اساس ضوابط محل خدمت عمل كند.(هر گونه بكارگيري خلاف شئونات طلبگي
            بايد توسط سرباز طلبه به مركز مديريت گزارش شود تا بررسي و برخورد لازم
            با ارگان متخلف صورت گيرد)
          </li>
          <li>
            ثبت نام انجام شده به منزله تاييد نهايي نيست.
          </li>
        </ol>
      </div>

      <br />
      <br />

      <div style="width: 100%">
        <v-simple-checkbox
          v-model="showNext"
          :ripple="false"
        ></v-simple-checkbox>
        <b>موارد فوق را با دقت مطالعه كردم و نسبت به رعایت آن متعهد مي شوم.</b>
      </div>
    </v-card>
    <div class="confirm">
      <v-btn
        class="register"
        v-if="showNext"
        :class="!isMobile ? 'btnMargin' : ''"
        color="primary white--text"
        rounded
        @click="applyRequest"
        :disabled="apiRunning"
      >
        {{ apiRunning ? "لطفا منتظر بمانید..." : "ارسال درخواست" }}
      </v-btn>
    </div>
    <app-dialog @close="onClose"></app-dialog>
  </div>
</template>

<script>
import { requestAmrieh } from "@/api/amrieh";
import Dialog from "@/components/Dialog";
export default {
  data() {
    return {
      showNext: false,
      showRequest: false,
      headers: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "text1",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "text2",
        },
      ],
      ranges: [
        {
          text1: "ثبت درخواست گواهی تلبس:",
          text2: "1 الی 15 هر ماه شمسی",
        },
        {
          text1: "تایید مدیریت حراست و صیانت حوزه علمیه خراسان:",
          text2: "1 هفته کاری",
        },
        {
          text1: "کارگاه های آموزش کاربردی تلبس:",
          text2: "16 الی 25 هر ماه شمسی ",
        },
        {
          text1: "آزمون حکم تلبس:",
          text2: "30 هر ماه شمسی",
        },
      ],
    };
  },
  components: {
    appDialog: Dialog,
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  created() {},

  methods: {
    closeDialog() {
      this.$store.commit("SET_DIALOG_SHOW", false);
    },

    applyRequest() {
      this.$store.commit("SET_API_RUNNING", true);
      requestAmrieh()
        .then((response) => {
          const data = response.data.Message;
          let message = "";
          try {
            if (JSON.parse(data).message == undefined) message = data;
            else if (JSON.parse(data).message.IsSuccess) {
              // message = JSON.parse(data).message.Body;
              message =
                "اطلاعات اولیه شما به سامانه امریه ارسال شد." +
                "<br/>" +
                "برای کسب اطلاعات بیشتر و ثبت درخواست امریه سربازی به تارنمای " +
                "<a target='_blank' href='http://dashboard.ismc.ir'>http://dashboard.ismc.ir</a>" +
                " مراجعه فرمایید.";
            } else {
              message = "خطا در سمت سرویس قم.";
            }

            this.$store.commit(
              "SET_DIALOG_ICON",
              JSON.parse(data).message.IsSuccess ? "check" : "exclamation"
            );
          } catch (e) {
            this.$store.commit("SET_DIALOG_ICON", "exclamation");
            message = data;
          }
          this.$store.commit("SET_DIALOG_TYPE", 0);

          this.$store.commit("SET_DIALOG_MESSAGE", message);
          this.$store.commit("SET_DIALOG_SHOW", true);
          // this.$store.commit(
          //   "SET_SNACKBAR_TEXT",
          //   JSON.parse(data).message.Body
          // );
          this.$store.commit("SET_API_RUNNING", false);
        })

        .catch((error) => {
          console.log(error);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
          this.$store.commit("SET_API_RUNNING", false);
        });
    },
    onClose() {
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
  /**
   * user changed date
   */
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}


.register2 {
  width: 300px !important;
  margin: 20px auto;
}
.v-text-field__details {
  display: none;
}


.v-simple-checkbox {
  top: -5px;
  position: relative;
  margin: 2px 0 0 5px;
  float: right;
}
.fullForm {
  margin-bottom: 65px;
}
</style>
<style>
.ranges .v-data-table__wrapper table tbody tr td:first-child {
  font-weight: bold;
}
.ranges .v-data-table__wrapper table {
  border: thin solid black !important;
}
</style>
